import React, { Component } from 'react';
import { ComboBox, MultiSelect } from '@progress/kendo-react-dropdowns';
import { Button } from '@progress/kendo-react-buttons';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { filterBy, orderBy } from '@progress/kendo-data-query';
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { getProjectResources } from '../../resourceManagement/ResourceService';
import { searchNotSubmittedTimeEntries, submitTimesheetAdmin } from './TimeSheetEntryService';
import moment from 'moment';
import SuccessImg from '../../ui/static/images/checked.svg';
import ErrorImg from '../../ui/static/images/cancel.svg';
import Loader from '../../integration/components/Loader';
import { LOG_TYPES } from "../../integration/IntegrationEnums";
import * as loggerService from "../../integration/LoggerService";

class TimeSheetSubmit extends Component {
    isMount = false;
    constructor(props) {
        super(props);
        this.state = {
            timeEntryData: [],
            selectedTimeEntries: [],
            resources: [],
            resourcesAll: [],
            selectedResource: [],
            startDate: null,
            endDate: null,
            isErrorMessageVisible: false,
            showMessageDialog: false,
            dialogMessage: '',
            dialogTitle: '',
            showSuccessImage: false,
            showErrorImage: false,
            skip: 0,
            take: 20,
            sort: [
                { field: 'updatedAt', dir: 'desc' }
            ],
            loading: false
        };
    }

    componentDidMount() {
        this.isMount = true;
        this.props.onHeaderTitleChange('Timesheet Submit');
        this.setState({
            loading: true,  
        });
        this.getAllActiveResources();
        this.setState({
            loading: false,  
        });
    }

    componentWillUnmount() {
        this.isMount = false;
    }

    handleSearch = async() => {
        if ((this.state.selectedResource && this.state.selectedResource.length === 0)  || !this.state.startDate || !this.state.endDate) {
            this.setState({ isErrorMessageVisible: true });
            return;
        }
        await this.setState({
            loading: true,  
        });
        let params = {
            SelectedResource: this.state.selectedResource,
            StartDate: moment(this.state.startDate).format('YYYY-MM-DD'),
            EndDate: moment(this.state.endDate).format('YYYY-MM-DD'),
            GlobalApprover: window.USER_PERMISSION.indexOf('APRV_TM_SHT_GLBL') > -1 ? true : false
        };
        await searchNotSubmittedTimeEntries(params).then(async res => {
            this.setState({
                timeEntryData: res.data,
                selectedTimeEntries: []
            });
        }).catch(error => {
            loggerService.writeLog(error, LOG_TYPES.ERROR);
        });
        await this.setState({
            loading: false,  
        });
    };

    handleSubmit = async() => {
        if ((this.state.selectedResource && this.state.selectedResource.length === 0)  || !this.state.startDate || !this.state.endDate) {
            this.setState({ isErrorMessageVisible: true });
            return;
        }
        await this.setState({
            loading: true,  
        });
        let params = {
            SelectedResource: this.state.selectedResource,
            StartDate: moment(this.state.startDate).format('YYYY-MM-DD'),
            EndDate: moment(this.state.endDate).format('YYYY-MM-DD'),
            SelectedTimeEntries: this.state.selectedTimeEntries,
        };
        await submitTimesheetAdmin(params).then(async res => {
            const message = `Timesheet submitted successfully.`;
            const title = 'Success';
            this.setState({
                selectedTimeEntries: [],
                showSuccessImage: true,
                showErrorImage: false,
                isErrorMessageVisible: false
            });
            this.toggleMessageDialog(message, title);
            this.handleSearch();
        }).catch(error => {
            loggerService.writeLog(error, LOG_TYPES.ERROR);
        });
        await this.setState({
            loading: false,  
        });
    };

    onClickCancel = () => {
        this.setState({ 
            selectedResource: null,
            startDate: null,
            endDate: null,
            isErrorMessageVisible: false,
            selectedTimeEntries: [] 
        });
    };

    getAllActiveResources = async () => {
        await getProjectResources() 
            .then(async res => {
            await this.setState({
                resources: res.data,
                resourcesAll: res.data,
            });
        })
        .catch(error => {
            loggerService.writeLog(error, LOG_TYPES.ERROR);
        });
    };

    toggleMessageDialog = (message, title) => {
        this.setState({
            showMessageDialog: !this.state.showMessageDialog,
            dialogMessage: message,
            dialogTitle: title,
        });
    };

    handleInputChange = event => {
        const valueObj = event.target.value;
        const field = event.target.name;
        if (this.isMount) {
            this.setState({
                [field]: valueObj
            });
        }
    };

    filterResources = event => {
        if (this.isMount) {
        this.setState({
            resources: this.filterData(event.filter, this.state.resourcesAll)
        });
        }
    };

    filterData(filter, allData) {
            const data = allData.slice();
            return filterBy(data, filter);
        }

    validateProperty = value => {
        if (value) {
            return 'd-none';
        } else {
            return 'inline-error';
        }
    };

    validateResource = value => {
        if (value && value.length > 0) {
            return 'd-none';
        } else {
            return 'inline-error';
        }
    };

    pageChange = event => {
        if (this.isMount) {
          this.setState({
            skip: event.page.skip,
            take: event.page.take
          });
        }
    };

    headerSelectionChange = (event) => {
        const checked = event.syntheticEvent.target.checked;
        this.state.timeEntryData.forEach(item => item.Selected = checked);
        this.forceUpdate();

        const selected = this.state.timeEntryData.filter(entry => entry.Selected === true);
        this.setState({
            selectedTimeEntries: selected
        });
    };

    selectionChange = async (event) => {
        event.dataItem.Selected = !event.dataItem.Selected;
        this.forceUpdate();

        const selected = await this.state.timeEntryData.filter(resource => resource.Selected === true);

        await this.setState({
            selectedTimeEntries: selected,
        });
    };

    render() {
        return (
            <div className="main-card">
                <div className="row">
                    <div className="col-md-9">
                        <div className="main-heading">Timesheet Submit</div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-4">
                        <div className="d-block">
                            <label>Resource:</label>
                        </div>
                        <div className="">
                            <MultiSelect
                                data={this.state.resources}
                                name="selectedResource"
                                textField="Name"
                                placeholder={'Please Select'}
                                onChange={this.handleInputChange}
                                value={this.state.selectedResource}
                                filterable={true}
                                onFilterChange={this.filterResources}
                            />                            
                            {this.state.isErrorMessageVisible === true ? (
                                <span className={this.validateResource(this.state.selectedResource)}>
                                    Please select a Resource
                                </span>
                            ) : null}
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-4">
                        <div className="d-block">
                            <label>Start Date:</label>
                        </div>
                        <div className="">
                            <DatePicker
                                name="startDate"
                                format="MM/dd/yyyy"
                                value={this.state.startDate}
                                onChange={this.handleInputChange}
                                formatPlaceholder={{ year: 'YYYY', month: 'MM', day: 'DD' }}
                            />                           
                            {this.state.isErrorMessageVisible === true ? (
                                <span className={this.validateProperty(this.state.startDate)}>
                                    Please select a Start Date
                                </span>
                            ) : null}
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="d-block">
                            <label>End Date:</label>
                        </div>
                        <div className="">
                            <DatePicker
                                name="endDate"
                                format="MM/dd/yyyy"
                                value={this.state.endDate}
                                onChange={this.handleInputChange}
                                formatPlaceholder={{ year: 'YYYY', month: 'MM', day: 'DD' }}
                            />                       
                            {this.state.isErrorMessageVisible === true ? (
                                <span className={this.validateProperty(this.state.endDate)}>
                                    Please select a End Date
                                </span>
                            ) : null}
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12 btn-align-right">
                        <Button primary={true} type="submit" onClick={this.handleSearch}>
                            Search
                        </Button>
                        <Button type="button" onClick={this.onClickCancel} style={{ marginRight: '5px' }}>
                            Clear
                        </Button>
                    </div>
                </div> 

                <div className="main-seperator" />

                <div className="row">
                    <div className="col-md-12">
                        <Grid
                            data={orderBy(this.state.timeEntryData, this.state.sort).slice(
                                this.state.skip,
                                this.state.take + this.state.skip
                            )}
                            skip={this.state.skip}
                            take={this.state.take}
                            total={this.state.timeEntryData.length}
                            resizable
                            pageable={true}
                            onPageChange={this.pageChange}
                            sortable={true}
                            sort={this.state.sort}
                            onSortChange={(e) => {
                                this.setState({
                                    sort: e.sort
                                });
                            }}
                            selectedField="Selected"
                            onHeaderSelectionChange={this.headerSelectionChange}
                            onSelectionChange={this.selectionChange}
                            className="search-result-grid"
                        >
                            <Column field="Selected" width="50px"/>     
                            <Column title="Resource" field="ResourceName" />
                            <Column title="Date" field="LogDateTime" />
                            <Column title="Project/Task Group" field="ProjectTaskGroup" />
                            <Column title="Task" field="TaskName" />
                            <Column title="Duration" field="Duration" />
                            <Column title="Comment" field="Comment" />
                        </Grid>
                    </div>
                </div>

                <div className="row my-2">
                    <div className="col-md-12 btn-align-right">
                        <Button
                            primary={true}
                            type="submit"
                            disabled={this.state.selectedTimeEntries.length <= 0}
                            onClick={this.handleSubmit}
                        >
                            Submit
                        </Button>
                    </div>
                </div> 

                {this.state.showMessageDialog === true && (
                    <Dialog title={this.state.dialogTitle} onClose={this.toggleMessageDialog} width="400px">
                        {this.state.showSuccessImage === true && (
                            <div className="text-center">
                            <img className="successImg" src={SuccessImg} alt="Success" />
                            </div>
                        )}
            
                        {this.state.showErrorImage === true && (
                            <div className="text-center">
                            <img className="successImg" src={ErrorImg} alt="Error Image" />
                            </div>
                        )}
                        <p style={{ margin: '25px', textAlign: 'center' }}>{this.state.dialogMessage}</p>
            
                        <DialogActionsBar>
                            <button className="k-button modal-primary" onClick={this.toggleMessageDialog}>
                                OK
                            </button>
                        </DialogActionsBar>
                    </Dialog>
                )}

                <Loader loading={this.state.loading} />          
            </div>
        );
    }
}

export default TimeSheetSubmit;